import Icon from '@ant-design/icons'
import type { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon'

// Calendar icon matching User's calendar.svg file:
// - Rounded outer frame
// - 2 rings on top
// - 4 columns x 3 rows grid of days inside
function AlertCalendarIconSVG() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Rounded outer frame */}
      <rect
        x="1.5"
        y="4.5"
        width="21"
        height="18"
        rx="2.5"
        stroke="currentColor"
        strokeWidth="2"
        fill="none"
      />

      {/* Horizontal line separating header */}
      <line
        x1="1.5"
        y1="9.5"
        x2="22.5"
        y2="9.5"
        stroke="currentColor"
        strokeWidth="2"
      />

      {/* Vertical column 1 */}
      <line
        x1="7"
        y1="9.5"
        x2="7"
        y2="22.5"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      {/* Vertical column 2 */}
      <line
        x1="12"
        y1="9.5"
        x2="12"
        y2="22.5"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      {/* Vertical column 3 */}
      <line
        x1="17"
        y1="9.5"
        x2="17"
        y2="22.5"
        stroke="currentColor"
        strokeWidth="1.5"
      />

      {/* Horizontal row 1 */}
      <line
        x1="1.5"
        y1="14"
        x2="22.5"
        y2="14"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      {/* Horizontal row 2 */}
      <line
        x1="1.5"
        y1="18.5"
        x2="22.5"
        y2="18.5"
        stroke="currentColor"
        strokeWidth="1.5"
      />

      {/* Left ring hook */}
      <path
        d="M7.5 2 C7.5 1.17 6.83 0.5 6 0.5 C5.17 0.5 4.5 1.17 4.5 2 L4.5 5 C4.5 5.83 5.17 6.5 6 6.5 C6.83 6.5 7.5 5.83 7.5 5 Z"
        stroke="currentColor"
        strokeWidth="1.8"
        fill="none"
        strokeLinecap="round"
      />

      {/* Right ring hook */}
      <path
        d="M19.5 2 C19.5 1.17 18.83 0.5 18 0.5 C17.17 0.5 16.5 1.17 16.5 2 L16.5 5 C16.5 5.83 17.17 6.5 18 6.5 C18.83 6.5 19.5 5.83 19.5 5 Z"
        stroke="currentColor"
        strokeWidth="1.8"
        fill="none"
        strokeLinecap="round"
      />
    </svg>
  )
}

export default function AlertCalendarNavIcon(
  props: Partial<CustomIconComponentProps>
) {
  return <Icon component={AlertCalendarIconSVG} {...props} />
}
